<div class="tab-pane show active fade details-view-results" id="trial-sites" role="tabpanel">
  <div class="details-view-results-head">
    <div class="trial-policy-toolbar" [formGroup]="filterForm" style="margin-bottom: 20px;">
      <div class="trial-policy-filter">
        <app-autosuggest-dropdown-input [options]="countryOptions" placeholder="Filter by Country..."
          [parentForm]="filterForm" controlName="country"
          (selectValueChanged)="onCountryChanged($event)"
          (cleared)="onCountryCleared()"></app-autosuggest-dropdown-input>
      </div>
      <div class="trial-policy-filter">
        <app-site-dropdown formControlName="siteId" [trialId]="selectedCountry ? trial.id : ''" [countryFilter]="selectedCountry"
          [siteIdFilter]="policySiteIds" [approvedOnly]="false" [assignedOnly]="false"
          placeholder="Filter by Site..." (selected)="onSiteSelected($event)"
          (cleared)="onSiteCleared()"></app-site-dropdown>
      </div>
      <app-button text="Expense Policy" faIcon="fas fa-plus" href="/trial/{{trial.id}}/policy/add" variant="info"
        [visible]="authService.hasPermission(Permissions.TrialPolicyAdd)" />
    </div>
  </div>

  <div class="trial-policy-list">
    <app-trial-policy-card *ngIf="!dataLoaded" [isLoading]="true"></app-trial-policy-card>
    <app-trial-policy-card *ngFor="let policy of filteredPolicies" [policy]="policy" (remove)="onRemovePolicy($event)"
      (edit)="onEdit($event)" (clone)="onClonePolicy($event)"></app-trial-policy-card>
  </div>
</div>

<!-- Start: Remove policy modal -->
<app-modal #removePolicyModal>
  <div class="modal-header">
    <h2 class="modal-title">Remove Expense Policy</h2>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to remove this expense policy from the trial?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" (clicked)="removePolicyModal.hide()" variant="secondary"
          width="fill"></app-button>
      </div>

      <div class="col-6">
        <app-button text="Yes, remove" (clicked)="onConfirmRemovePolicy()" width="fill"></app-button>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Remove policy modal -->

<!-- Start: Clone policy modal -->
<app-trial-policy-clone #clonePolicyModal (cloned)="loadPolicies()" />
<!-- End: Clone policy modal -->
